export const options = [
  {
    id: 'industrial-printing-landing-productivity',
    type: 'video',
    bgImage: 'https://cdn.printos.com/images/signin/promos/productivity-pack.jpg',
    // height: 'scale',
    // scale: 4.8,
    style: {backgroundPosition: '50% 50%'},
    message: 'start.ProductivityVideo',
    messageStyle: {textShadow: '2px 2px 4px #5a5a5a'},
    video: {
      id: 'NZ2IBdZ9vRY',
    },
    // iconLink: {
    //   url: 'https://www.linkedin.com/feed/update/urn:li:ugcPost:7262470333532672001/',
    //   style: {
    //     position: 'absolute',
    //     top: '16px',
    //     right: '16px',
    //   },
    //   iconPath: 'landing-page/linkedin.svg',
    //   iconStyle: {
    //     backgroundColor: 'white',
    //     borderRadius: '4px',
    //   },
    //   iconSize: 48,
    // },
    dateRange: {
      start: '2025-01-12',
      end: '2025-01-27',
    }
  },
  {
    id: 'industrial-printing-landing-quality',
    type: 'video',
    bgImage: 'https://cdn.printos.com/images/signin/promos/quality-pack.jpg',
    style: {minHeight: '1024px', backgroundPosition: '50% 30%'},
    messageStyle: {textShadow: '2px 2px 4px #5a5a5a'},
    message: 'start.QualityVideo',
    video: {
      id: 'jex-SX4cedQ',
    },
    // iconLink: {
    //   url: 'https://www.linkedin.com/feed/update/urn:li:ugcPost:7262470333532672001/',
    //   style: {
    //     position: 'absolute',
    //     top: '16px',
    //     right: '16px',
    //   },
    //   iconPath: 'landing-page/linkedin.svg',
    //   iconStyle: {
    //     backgroundColor: 'white',
    //     borderRadius: '4px',
    //   },
    //   iconSize: 48,
    // },
    dateRange: {
      start: '2025-01-28',
      end: '2025-02-10',
    }
  },
  {
    id: 'industrial-printing-landing-creativity',
    type: 'video',
    bgImage: 'https://cdn.printos.com/images/signin/promos/creativity-pack.jpg',
    style: {minHeight: '1024px', backgroundPosition: '50% 10%'},
    messageStyle: {textShadow: '2px 2px 4px #5a5a5a'},
    message: 'start.CreativityVideo',
    video: {
      id: 'zK1lceLpsy0',
    },
    // iconLink: {
    //   url: 'https://www.linkedin.com/feed/update/urn:li:ugcPost:7262470333532672001/',
    //   style: {
    //     position: 'absolute',
    //     top: '16px',
    //     right: '16px',
    //   },
    //   iconPath: 'landing-page/linkedin.svg',
    //   iconStyle: {
    //     backgroundColor: 'white',
    //     borderRadius: '4px',
    //   },
    //   iconSize: 48,
    // },
    dateRange: {
      start: '2025-02-11',
      end: '2025-02-24',
    }
  },
  {
    id: 'industrial-printing-landing-automation',
    type: 'video',
    bgImage: 'https://cdn.printos.com/images/signin/promos/automation-pack.jpg',
    style: {minHeight: '1024px', backgroundPosition: '50% 20%'},
    messageStyle: {textShadow: '2px 2px 4px #5a5a5a'},
    message: 'start.AutomationVideo',
    video: {
      id: 'Qt61QhYLsoo',
    },
    // iconLink: {
    //   url: 'https://www.linkedin.com/feed/update/urn:li:ugcPost:7262470333532672001/',
    //   style: {
    //     position: 'absolute',
    //     top: '16px',
    //     right: '16px',
    //   },
    //   iconPath: 'landing-page/linkedin.svg',
    //   iconStyle: {
    //     backgroundColor: 'white',
    //     borderRadius: '4px',
    //   },
    //   iconSize: 48,
    // },
    dateRange: {
      start: '2025-02-24',
      end: '2025-03-10',
    }
  },
  {
    id: 'industrial-printing-landing',
    type: 'video-scale',
    color: '#9d388c',
    bgImage: 'https://cdn.printos.com/images/landings/drupa-splash.jpg',
    height: 'scale',
    scale: 4.8,
    style: {},
    customClass: 'drupa-background',
    // iconLink: {
    //   url: 'https://www.linkedin.com/feed/update/urn:li:ugcPost:7262470333532672001/',
    //   style: {
    //     position: 'absolute',
    //     top: '16px',
    //     right: '16px',
    //   },
    //   iconPath: 'landing-page/linkedin.svg',
    //   iconStyle: {
    //     backgroundColor: 'white',
    //     borderRadius: '4px',
    //   },
    //   iconSize: 48,
    // },
    dateRange: {
      start: '2025-03-11',
    }
  },
  {
    type: 'transition-small',
    bg: '#7856a4',
    // bg: 'linear-gradient(90deg, rgba(151, 56, 134, 1) 30%, rgba(0, 150, 214, 1))',
    button: {
      title: 'start.SignIn_LearnAboutPrintOS',
      url: 'https://www.hp.com/us-en/industrial-printers/indigo-digital-presses/printosx-software-solutions.html',
      newTab: true,
      ga: {
        category: 'start',
        action: 'What is PrintOS Button - Clicked',
      },
    },
  },
  {
    type: 'info-static-column',
    bg: '#7856a4',
    // bg: 'linear-gradient(90deg, rgba(151, 56, 134, 1) 30%, rgba(0, 150, 214, 1))',
    watermarks: [
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '240',
        top: 0,
        left: '-40px',
        iconColor: '#fff',
      },
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '160',
        top: '160px',
        left: '680px',
        iconColor: '#fff',
      },
      {
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-solid.svg',
        iconSize: '220',
        top: '-20px',
        left: '930px',
        iconColor: '#fff',
      },
    ],
    options: [
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'orgCount',
        title: 'start.Landing_Category1',
        message: 'start.Landing_Details1'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'userCount',
        title: 'start.Landing_Category2',
        message: 'start.Landing_Details2'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/pos-cloud-outline.svg',
        iconSize: '220',
        // iconColor: '#fff',
        iconOutline: true,
        overlay: 'deviceCount',
        title: 'start.Landing_Category3',
        message: 'start.Landing_Details3'
      },
    ],
  },
  {
    type: 'info-static-column',
    theme: 'light1',
    message: 'start.SignIn_WhatDoesPrintOSDo',
    align: 'center',
    options: [
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
        iconSize: '120',
        iconColor: '#973886',
        title: 'start.Pillar_Optimize',
        message: 'start.Pillar_Optimize_Highlight',
        content: 'start.Pillar_Optimize_Details'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
        iconSize: '120',
        iconColor: '#4b67ae',
        title: 'start.Pillar_Automate',
        message: 'start.Pillar_Automate_Highlight',
        content: 'start.Pillar_Automate_Details'
      },
      {
        align: 'center',
        iconUrl: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
        iconSize: '120',
        iconColor: '#0096d6',
        title: 'start.Pillar_Grow',
        message: 'start.Pillar_Grow_Highlight',
        content: 'start.Pillar_Grow_Details'
      },
    ],
  },
  {
    type: 'transition-small',
    bg: '#55acc7',
    message: 'start.Pillar_Optimize_Section',
    messageIcon: {
      url: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
      color: 'white',
      size: '48',
    },
  },
  {
    type: 'carousel',
    bg: '#212121',
    panelIndex: 0,
    transition: '.5s',
    panels: [
      {
        id: 'print-beat-app',
        panelImage: 'https://cdn.printos.com/images/market/products/summary/print-beat/lf-printbeat-report-blog.png',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/printbeat.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'app.printbeat_Name',
        // message: '',
        content: "start.PrintBeat_Desc",
        bullets: [
          "start.PrintBeat_Bullet1",
          "start.PrintBeat_Bullet2",
          "start.PrintBeat_Bullet3"
        ],
        video: {
          //id: '86BHQ1vGzyM',
          id: 'oqZshkSDV-Y',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        id: 'printos-mobile-app',
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/Image7.jpg',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/print-beat-mobile.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'start.PrintBeatMobile_Title',
        // message: '',
        content: 'start.PrintBeatMobile_Desc',
        video: {
          id: 'a3zlL8q9SZ0',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        id: 'knowledge-zone-app',
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/move-to-digital.jpg',
        //panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/PrintBeat@2x.png',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/information-center.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'app.information-center_Name',
        // message: '',
        content: 'start.KZ_Desc',
        video: {
          id: '5YL7dQeqwK8',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/Service%20center@2x.png',
        // contentOnRight: true,
        title: 'app.pwi-sc_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/pwi-sc.svg',
        iconSize: '48',
        iconColor: 'white',
        content: 'start.IndigoSC_Desc',
        video: {
          id: '4cg4_K8tCKo',
        },
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      // {
      //   bgImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/site-flow.jpg',
      //   // contentOnRight: true,
      //   title: 'Jobs API & Print Beat Job reports',
      //   // message: '',
      //   content: 'Increase profits by growing, optimizing, and controlling your print shop from pre-press to post press.',
      //   link: {
      //     title: 'start.LearnMore',
      //     url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
      //   },
      // },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/printos/Hero_Banner_Desktop@2x%20%281%29.jpg',
        // contentOnRight: true,
        title: 'app.csm_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/csm.svg',
        iconSize: '48',
        iconColor: 'white',
        content: 'start.SubstrateManager_Desc',
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/LF_PrintOS-Media_locator-290x290%20-%20Luis%20Medina.png',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/ml.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'app.ml_Name',
        video: {
          id: 'P1FpauyAPmc',
        },
        // message: '',
        content: 'start.MediaLocator_Desc',
        link: {
          title: 'start.Link_GoNow',
          url: 'https://www.printos.com/ml/#/medialocator',
        },
      },
    ],
  },
  {
    type: 'transition-small',
    bg: '#55acc7',
    message: 'start.Pillar_Automate_Section',
    messageIcon: {
      url: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
      color: 'white',
      size: '48',
    },
  },
  {
    type: 'carousel',
    bg: '#212121',
    panelIndex: 0,
    transition: '.5s',
    panels: [
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/site-flow.jpg',
        // contentOnRight: true,
        title: 'app.production_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/production.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'uozKYYcKsJM'
        },
        content: 'start.SiteFlow_Desc',
        link: {
          title: 'start.LearnMore',
          url: 'https://hpsiteflow.com/',
        },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/printos/Video1_HP%20PrintOS_Desktop@2x%20%281%29.jpg',
        // contentOnRight: true,
        title: 'app.box_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/box.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'noRCwtBzDhs',
        },
        content: 'start.Box_Desc',
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/Image9.jpg',
        // contentOnRight: true,
        title: 'app.imposer_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/imposer.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'At77w-mghUo',
        },
        content: 'start.Imposer_Desc',
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/large-formats/printos/PrintBeat@2x.png',
        // contentOnRight: true,
        title: 'app.composer_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/composer.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'WUvQ3KIqDd4',
        },
        content: 'start.Composer_Desc',
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/industrial-printers/indigo-digital-presses/printosx-software-service-solutions/hero-banner.jpg',
        // contentOnRight: true,
        title: 'app.resourcemanager_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/resourcemanager.svg',
        iconSize: '48',
        iconColor: 'white',
        video: {
          id: 'xdako_WrlAk'
        },
        content: 'start.ResourceManager_Desc',
        // link: {
        //   title: 'start.LearnMore',
        //   url: 'https://www.hp.com/us-en/industrial-printers/print-workflow-automation-management-solutions-site-flow.html',
        // },
      },
    ],
  },
  {
    type: 'transition-small',
    bg: '#55acc7',
    message: 'start.Pillar_Grow_Section',
    messageIcon: {
      url: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
      color: 'white',
      size: '48',
    },
  },
  {
    type: 'carousel',
    bg: '#212121',
    panelIndex: 0,
    transition: '.5s',
    panels: [
      {
        panelImage: 'https://cdn.printos.com/images/landing-page/2x/Transform.png',
        // contentOnRight: true,
        iconUrl: 'https://cdn.printos.com/images/application/icons/marketplace.svg',
        iconSize: '48',
        iconColor: 'white',
        title: 'start.marketplace-ideas_Name',
        // message: '',
        content: 'start.marketplace-ideas_Desc',
      },
      {
        panelImage: 'https://www.hp.com/content/dam/sites/worldwide/printers/printos/Video2_HP%20PrintOS_Desktop@2x%20%281%29.jpg',
        // contentOnRight: true,
        title: 'start.marketplace-licenses_Name',
        // message: '',
        iconUrl: 'https://cdn.printos.com/images/application/icons/marketplace.svg',
        iconSize: '48',
        iconColor: 'white',
        content: 'start.marketplace-licenses_Desc',
      },
    ],
  },
];
